module.exports = __webpack_public_path__ + "img/mind_skeleton_time_2.25dee434.png";